import { RARITY_TIERS, rarityRank } from "@/lib/rarity";
import { BASE_TIER, tierForRarity } from "@/lib/reveal/tiers";

import type { RevealTier } from "@/lib/reveal/tiers";

/**
 * The tier a card reveals at: the rarity its edition declares, and nothing
 * else.
 *
 * Rarity and print finish are independent axes in the release. Every face
 * carries one rarity and keeps it across all three of its finishes, so a
 * Common face is Common whether it was printed Base, Foil or Serialized —
 * checked against all 360 editions in `contracts/catalog/print-run-source.csv`,
 * and confirmed as the rule the ceremony follows.
 *
 * Finish is reported on its own, in the inventory's "Foiled" and serial rows.
 * It must not reach the ceremony: letting it raise the tier would give a
 * serialized Common the same reveal as a one-of-one Legendary.
 *
 * Matching is case-insensitive and ignores surrounding space, because the
 * catalog schema types `rarity` as a free-form string. A tier this build does
 * not recognise reveals at the base tier — a plain turn, never a ceremony
 * invented from a word nobody has defined.
 */
export function resolveTier(rarity: string | undefined): RevealTier {
  const rank = rarityRank(rarity);
  if (rank === undefined) return BASE_TIER;
  const named = RARITY_TIERS[rank - 1];
  return named === undefined ? BASE_TIER : tierForRarity(named);
}
